<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5YgWPW/Images/WilsonCovers3.jpg?1692202093758" alt="This image is the cover for the book Casebook of Murder"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Casebook of Murder
      </h1>
      <p class="bookDescription body article font2">
        <b>From the bestselling author of <i>The Outsider</i>, an exhaustive historical true crime survey.</b><br/>  <br/> Colin Wilson, co-author of the bestselling <i>Encyclopedia of Murder</i>, has written a definitive volume on the world’s major cases of violent murder. In doing so, he traces the history of violence from its beginnings. From Sawney Bean and his cannibal family to Ed Gein, the Wisconsin Necrophile, Wilson illustrates the “changing fashions of murder” and indicates some hope for the future.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Colin Wilson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ba2baac